import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/cultural-platform.css';

const FooterModern = () => {
  const currentYear = new Date().getFullYear();
  
  // Official logo URL
  const logoUrl = "https://customer-assets.emergentagent.com/job_soft-influence-1/artifacts/g6p6wvoo_Copy%20of%20Copy%20of%20Copy%20of%20PROJECT%20SOFT%20POWER%20LOGO.PNG";
  
  const emails = [
    'info@projectsoftpower.org',
    'leanderleemarty@projectsoftpower.org',
    'nishaleemarty@projectsoftpower.org',
    'chandrashankar@projectsoftpower.org'
  ];
  
  const phones = [
    '+91 9677774667',
    '+91 8754494401',
    '+62 8127007099'
  ];

  return (
    <footer className="cultural-footer">
      <div className="cultural-footer-content">
        {/* Brand Section */}
        <div className="cultural-footer-brand">
          <img 
            src={logoUrl}
            alt="Project Soft Power Logo"
            style={{
              height: '60px',
              width: 'auto',
              marginBottom: '16px',
              background: 'white',
              padding: '8px',
              borderRadius: '4px'
            }}
          />
          <h3 className="cultural-footer-title">Project Soft Power</h3>
          <p className="cultural-footer-description">
            <strong>International Strategic Arts, Films and Cultural Development Initiative</strong>
          </p>
          <p className="cultural-footer-description">
            Founded by Leander Lee Marty
          </p>
          <p className="cultural-footer-description" style={{ fontSize: '12px', marginTop: '16px' }}>
            Independent Government Allied Organisation
          </p>
        </div>

        {/* Pages */}
        <div className="cultural-footer-section">
          <h4>Pages</h4>
          <ul className="cultural-footer-links">
            <li className="cultural-footer-link"><Link to="/">Home</Link></li>
            <li className="cultural-footer-link"><Link to="/about">About</Link></li>
            <li className="cultural-footer-link"><Link to="/arts">Arts</Link></li>
            <li className="cultural-footer-link"><Link to="/films">Films</Link></li>
            <li className="cultural-footer-link"><Link to="/culture">Culture</Link></li>
            <li className="cultural-footer-link"><Link to="/team">Leadership</Link></li>
            <li className="cultural-footer-link"><Link to="/latest-release">Our Latest Release</Link></li>
            <li className="cultural-footer-link"><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="cultural-footer-section">
          <h4>Contact</h4>
          <ul className="cultural-footer-links">
            {emails.map((email, index) => (
              <li key={index} className="cultural-footer-link">
                <a href={`mailto:${email}`}>{email}</a>
              </li>
            ))}
            {phones.map((phone, index) => (
              <li key={index} className="cultural-footer-link">
                <a href={`tel:${phone}`}>{phone}</a>
              </li>
            ))}
          </ul>
          <p style={{ fontSize: '12px', color: '#9AA0A6', marginTop: '12px', fontStyle: 'italic' }}>
            An international organization operating across cultures and borders.
          </p>
        </div>
      </div>

      <div className="cultural-footer-bottom">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img 
            src={logoUrl}
            alt="PSP"
            style={{
              height: '28px',
              width: 'auto',
              background: 'white',
              padding: '4px',
              borderRadius: '4px'
            }}
          />
          <span>© {currentYear} Project Soft Power. All rights reserved.</span>
        </div>
        <div>
          One world. Many nations. One shared responsibility.
        </div>
      </div>
    </footer>
  );
};

export default FooterModern;
